import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react'
import { useAuthHandling } from '../useAuthhandling';
import { Link, useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import Config from '../Config';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';

function Blogview() {
    let navigate = useNavigate();
    const { isAuthorized, handleUnauthorized } = useAuthHandling();

    const tokens = Cookies.get("a_token");
    if (!tokens) {
        navigate("/");
    }
    const [blog, setBlog] = useState([]);
    const [date, setDate] = useState("");

    let { id } = useParams();
    let name, value;

    const getinfo = async (e) => {
        const res = await fetch(`${Config.apiurl}/api/v1/crm/blog/get-blog/${id}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${Cookies.get("a_token")}`,
            },
        });
        if (res.status === 200) {
            const data = await res.json();
            setBlog(data.data);
            setDate(moment(data.data.publishDate).utc().format("YYYY-MM-DD"));
        }
        else if (res.status === 401) {
            handleUnauthorized();
            getinfo();
        }
        else {
            alert("error");
        }
    };

    useEffect(() => {
        getinfo();
    }, []);

  const renderHTML = (description) => {
      return <span dangerouslySetInnerHTML={{ __html: description }} />;
  };
  
    return (
        <div className="container-scroller">
            <Navbar />

            <div className="container-fluid page-body-wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <div className='view_page_top'>
                            <Link to="/bloglist">Blog list</Link>
                            <Link to={"/editblog/" + id}>Edit</Link>
                        </div>
                        <div className="row">
                            <div className="col-md-12 grid-margin stretch-card">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title">Blog View page</h4>

                                        <div className='row view_div_row'>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6>Title </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p> {blog.title}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-6'>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Slug </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p>  {blog.slug}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Author type </h6>
                                                    </div>

                                                    <div className='view_portion_p'>
                                                        <p>  {blog.authorType}</p>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Author name </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p>  {blog.professionalAuthor}</p>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Publish Date </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p>  {date}</p>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Status </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p>  {blog.status===true?"Active":"In Active"}</p>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6>Draft/Publish </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p>  {blog.draft===false?"Publish":"Draft"}</p>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='col-12 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Description </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p> {renderHTML(blog.description)}</p>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className='col-12 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Meta Title </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p>  {blog.metaTitle}</p>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className='col-12 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Meta Description </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p>  {blog.metaDescription}</p>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='col-12 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Image </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                    {blog?.blogImage?.length !== 0
                              ? blog?.blogImage?.map((elements, index) => {
                                  return (
                                    <div key={index}  className="position-relative col-md-2"
                                    style={{
                                      width: "107px",
                                      height: "100px",
                                      marginTop: "5px",
                                      //  marginRight: "5px",
                                    }}
                                    >
                                      <img
                                        src={elements.imageFile}
                                        alt=""
                                      
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                          marginTop: "5px",
                                          marginLeft: "5px",
                                        }}
                                      />

                                    
                                    </div>
                                  );
                                })
                              : ""} 

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Blogview
